import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface UploadFileMeta {
  name: string;
  description: string;
  sensitive: boolean;
}

async function uploadCompanyFiles(
  companyId: string,
  files: File[],
  meta: UploadFileMeta[],
  auth: Authentication | null
): Promise<void> {
  try {
    if (!auth) throw new UploadCompanyFilesFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    formData.append('meta', JSON.stringify(meta));

    const response = await HttpClient.post(
      `/backoffice/companies/${companyId}/files/upload`,
      formData,
      auth.token,
      true
    );

    if (!response.success) throw new UploadCompanyFilesFailure(response.message, response.code);
  } catch (e) {
    if (e instanceof UploadCompanyFilesFailure) throw e;
    const errMessage = e instanceof Error ? e.message : 'Une erreur inattendue s’est produite.';
    throw new UploadCompanyFilesFailure(
      errMessage.trim() || 'Erreur réseau ou serveur. Réessayez plus tard.',
      'request-failed'
    );
  }
}

export class UploadCompanyFilesFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default uploadCompanyFiles;
